export default __webpack_public_path__ + "static/media/wa_0001.12e2179f.jpg";